import * as React from 'react';
import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const LibrarySvg: React.FC<Props> = ({ color = '#000', ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        d="M4 4h16v2H4V4zm0 4h10v2H4V8zm0 4h16v2H4v-2zm0 4h10v2H4v-2z"
      />
    </svg>
  );
};

export default LibrarySvg;
